"use client"

import { motion } from "framer-motion"
import { Button } from "@/components/ui/button"
import { CalendarPlus } from "lucide-react"
import { trackEvent } from "@/lib/analytics"

type CTA15MinProps = {
  onBook?: (source?: string) => void
}

export function CTA15Min({ onBook }: CTA15MinProps = {}) {
  const openBooking = (location: string) => {
    try {
      trackEvent('book_appointment_click', { location })
    } catch {}
    if (onBook) {
      onBook(location)
    } else if (typeof window !== 'undefined' && (window as any).openBookingModal) {
      ;(window as any).openBookingModal(location)
    }
  }

  return (
    <section className="bg-[rgb(132,137,116)] py-12 lg:py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-normal text-white mb-4">
            Not sure if this is the right fit?
          </h2>
          <p className="text-white/90 mb-8 text-lg">
            You're welcome to book a free 15-minute phone consult to talk through your needs with Renee and see if Chinese Medicine and acupuncture feel right for you.
          </p>
          <Button
            variant="outline"
            className="border-2 border-white text-white hover:bg-white hover:text-[rgb(132,137,116)]"
            onClick={() => openBooking('not_sure_free_consult')}
            aria-label="Free 15min Phone Consult"
          >
            <span className="inline-flex items-center gap-2">
              <CalendarPlus className="h-4 w-4" aria-hidden="true" />
              Free 15min Phone Consult
            </span>
          </Button>
        </motion.div>
      </div>
    </section>
  )
}

